import { IntervalType } from "./AnalyticsDashboard";
import { formatISO } from "date-fns";
import { z } from "zod";

const OrganDetailsSchema = z.object({
	average_duration: z.number(),
	missions: z.number(),
});

const AnalyticsSchema = z.object({
	date: z.string(),
	organs: z.record(OrganDetailsSchema),
});

export type AnalyticsData = z.infer<typeof AnalyticsSchema>;

type OrganKey = "missions" | "average_duration";

export const fetchAnalyticsData = (
	startDate: Date,
	endDate: Date,
	interval: IntervalType
): Promise<AnalyticsData[]> => {
	if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
		return Promise.reject("Invalid date");
	}

	const params = new URLSearchParams({
		start_date: formatISO(startDate),
		end_date: formatISO(endDate),
		interval: interval,
	});

	return fetch(`/api/analytics?${params.toString()}`).then((response) => {
		if (!response.ok) {
			throw new Error("Failed to fetch analytics data");
		}
		return response.json();
	});
};

const convertSecondsToHours = (seconds: number): number => {
	return Math.round((seconds / 3600 + Number.EPSILON) * 100) / 100;
};

export const createDataset = (
	data: any[],
	selectedOrgans: string[],
	key: OrganKey
) => {
	return selectedOrgans.map((organ) => ({
		label: organ,
		data: data.map((item) => {
			const value = item.organs[organ]?.[key];
			return key === "average_duration"
				? convertSecondsToHours(value)
				: value || 0;
		}),
	}));
};
